import { OrderedOptions } from './dto';

export const formatOptions = (options: OrderedOptions[]) =>
  options.map((option) => option.name).join(', ');
